var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{staticClass:"hidden-sm-and-down header",attrs:{"app":""}},[_vm._v(" Copyright © 2018-2020 by BORA-DOPA All Rights Reserved. Powered by CDT-MOI-CW "),_c('v-spacer'),_vm._v(" v "+_vm._s(_vm.v)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }